export const KNOWLEDGE_BASE_URL = 'https://knowledgebase.parspec.io/knowledge/terms-of-service';

export const HIDDEN_XFDF = '<?xml version="1.0" ?><annots></annots>';

export const CONTACT_PARSPEC_LINK = 'https://meetings.hubspot.com/parspec/contact';

export const ACCOUNT_CREATION_HELP_URL = 'https://knowledgebase.parspec.io/knowledge/account-creation';

export enum EVENT_SERVICE_PAGENAME_VALUES {
    BIDBOARD = 'bidboard',
    BOM = 'bom',
    REPORTING_CUSTOMERS = 'reporting_customers',
    REPORTING_QUOTE_OWNERS = 'reporting_users',
    REPORTING_BRANCH_LOCATIONS = 'reporting_branch_locations',
    REPORTING_MANUFACTURERS = 'reporting_manufacturers',
    DASHBOARD_PROJECTS = 'dashboard_projects',
    DASHBOARD_QUOTE = 'dashboard_quote',
    DASHBOARD_SUBMITTAL = 'dashboard_submittal',
    DASHBOARD_OM = 'dashboard_om',
    DASHBOARD_BOM = 'dashboard_bom',
    PRICING_HISTORY = 'pricing_history',
    BOM_DOCUMENTS = 'bom_documents_tab',
    BOM_PRICING = 'bom_pricing_tab',
    BOM_PRICING_MANUFACTUER_VIEW = 'bom_pricing_manufacturer_view',
    BOM_SPECIFICATIONS = 'bom_specifications_tab',
    BOM_DATASHEET = 'bom_datasheet_tab'
}

export const QUOTE_DOCUMENT_AUTOMATION_STATUSES = ['Won', 'Lost', 'Abandoned'];
